import React from 'react';
import { iconSizer } from "../../../internal/icons2022/iconSizer";
import { CheckAIcon16Solid } from "../../../internal/icons2022/CheckAIcon/CheckAIcon16Solid";
import { CheckAIcon20Solid } from "../../../internal/icons2022/CheckAIcon/CheckAIcon20Solid";
export var CheckedIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(CheckAIcon16Solid, {
      size: 12
    });
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(CheckAIcon16Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(CheckAIcon20Solid, null);
  }
}, 'CheckedIcon');